import type { FireIconProps } from './types';

export default function MalteseCross({ size = 24, color = 'currentColor', strokeWidth = 2, className, ...props }: FireIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
      fill="none" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      className={className} {...props}>
      {/* Maltese cross — 4 V-shaped arms */}
      <path d="M9 2l-2 4h-3l-2 3 4 2v2l-4 2 2 3h3l2 4h6l2-4h3l2-3-4-2v-2l4-2-2-3h-3l-2-4z" />
    </svg>
  );
}
